import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../storage.service';
import { TotemService } from '../totem.service';
import { estacionamientos } from './estacionamientos';
import { AnalyticsService } from '../services/analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-estacionamientos',
  templateUrl: './estacionamientos.component.html',
  styleUrls: ['./estacionamientos.component.css']
})
export class EstacionamientosComponent implements OnInit {
  public actual: string = '';
  listaEstacionamientos: any[] = [];

  constructor(
    private router: Router,
    private storageService: StorageService,
    private totemService: TotemService,
    private analytics: AnalyticsService
  ) {}

    async ngOnInit() {
    this.actual = this.totemService.actualLanguage;
    this.listaEstacionamientos = estacionamientos || [];

    // Telemetría: sección Servicios
    this.analytics.sendSectionView('Servicios');
    this.analytics.sendPageView('/servicios/estacionamientos', 'Sección: Servicios - Estacionamientos');
  }

  /**
   * Iniciar ruta hacia un estacionamiento.
   * Este metodo es el que invoca el template (estacionamientos.component.html).
   *
   * Antes el template llamaba a iniciarRuta(est.piid) pero el .ts solo tenia
   * abrirEstacionamiento(item), por lo que el click no hacia nada. Aqui unificamos:
   *  1) guardamos destino en storage (para que donde-quiero-ir lo use),
   *  2) emitimos analytics (service_view + page_view), y
   *  3) navegamos a la pantalla de seleccion de origen.
   */
  async iniciarRuta(piid: any) {
    // Buscamos el item completo por si el template solo nos da el piid,
    // asi podemos enriquecer la analitica con nombre y piso.
    const item = (this.listaEstacionamientos || []).find((e: any) => e && e.piid === piid) || { piid };
    const nombre = (item && (item.nombre || item.descripcion)) || 'Estacionamiento';
    const piso = item && (item.piso || item.piso_numero);

    // Persistir destino para la siguiente pantalla
    this.storageService.setDestino(String(piid), 'estacionamiento');

    // Telemetria — usamos el evento dedicado parking_view y un titulo de
    // page_view especifico ("Estacionamiento: ...") para que en el reporte
    // de GA4 "Vistas por titulo de pagina" se distingan los estacionamientos
    // de los servicios genericos.
    try {
      this.analytics.sendParkingView(nombre, piso, piid);
      this.analytics.sendPageView('/estacionamiento/' + (piid || 'est'), 'Estacionamiento: ' + nombre);
    } catch (err) {
      console.warn('GA4 estacionamiento track error', err);
    }

    // Navegacion
    this.router.navigate(['donde-quiero-ir']);
  }

  /**
   * Alias retrocompatible por si otros templates o llamadas internas
   * todavia referencian abrirEstacionamiento(item).
   */
  abrirEstacionamiento(item: any) {
    const piid = item && (item.piid || item.poi_id || item.puntoInteres);
    return this.iniciarRuta(piid);
  }



  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }

  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word) return word[0].texto_descripcion;
  }
}
